module.exports = __webpack_public_path__ + "img/minjiangqr.71f13d76.jpg";